import { withCache } from './withCache.js';

function createCacheWrapper(options) {
  return withCache((cb) => cb(), options);
}

export { createCacheWrapper };
//# sourceMappingURL=createCacheWrapper.js.map
